var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('AppBar'),_c('div',{staticClass:"fill-height d-flex align-center justify-center"},[_c('div',{staticClass:"text-center"},[_c('v-icon',{attrs:{"size":"200"}},[_vm._v(" "+_vm._s(_vm.$route.meta.icon)+" ")]),_c('br'),_vm._v(" TBD: "+_vm._s(_vm.$route.meta.title)+" ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }